import {Component} from "react";

class OperatorElement extends Component {
    render() {
        return '';
    }
}

export default OperatorElement;
